import { type FDealType, getDealTypeFromJsonQuery } from '@/packages/JsonQuery';

import { useFiltersContext } from './context';

export function useDealType(): FDealType {
  const { jsonQuery } = useFiltersContext();

  return getDealTypeFromJsonQuery(jsonQuery);
}
